import React from 'react';
import { N600 } from '@atlaskit/theme/colors';
import PeopleIcon from '@atlaskit/icon/glyph/people';
export const extractSubscriberCount = jsonLd => {
  const subscriberCount = jsonLd['atlassian:subscriberCount'];
  if (subscriberCount) {
    return {
      text: subscriberCount.toString(),
      icon:
      /*#__PURE__*/
      // eslint-disable-next-line @atlaskit/design-system/no-legacy-icons -- TODO - https://product-fabric.atlassian.net/browse/DSP-19499
      React.createElement(PeopleIcon, {
        size: "small",
        label: "subscribers",
        primaryColor: `var(--ds-icon-subtle, ${N600})`
      })
    };
  }
};